"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventTrackingService = void 0;
const runtimeConfig_1 = require("../runtimeConfig");
const providers_1 = require("../providers");
const commands_1 = require("../commands");
class EventTrackingService {
    constructor(...[configuration]) {
        this.config = (0, runtimeConfig_1.getRuntimeConfig)(configuration || { eventTarget: providers_1.TrackingTargetProviderEnum.GOOGLE_ANALYTICS });
    }
    doTrackSignInEvent(input) {
        const command = new commands_1.SignInCommand(input);
        return this.execute(command);
    }
    doTrackSignUpEvent(input) {
        const command = new commands_1.SignUpCommand(input);
        return this.execute(command);
    }
    doTrackIdentifyUserEvent(input) {
        const command = new commands_1.IdentifyUserCommand(input);
        return this.execute(command);
    }
    doTrackViewContentEvent(input) {
        const command = new commands_1.ViewContentCommand(input);
        return this.execute(command);
    }
    doTrackAddToCartEvent(input) {
        const command = new commands_1.AddToCartCommand(input);
        return this.execute(command);
    }
    doTrackRemoveFromCartEvent(input) {
        const command = new commands_1.RemoveFromCartCommand(input);
        return this.execute(command);
    }
    doTrackSearchEvent(input) {
        const command = new commands_1.SearchCommand(input);
        return this.execute(command);
    }
    doTrackInitiateCheckoutEvent(input) {
        const command = new commands_1.InitiateCheckoutCommand(input);
        return this.execute(command);
    }
    doTrackAddPaymentInfoEvent(input) {
        const command = new commands_1.AddPaymentInfoCommand(input);
        return this.execute(command);
    }
    doTrackPurchaseEvent(input) {
        const command = new commands_1.PurchaseCommand(input);
        return this.execute(command);
    }
    doTrackPromotionCodeUsedEvent(input) {
        const command = new commands_1.PromotionCodeUsedCommand(input);
        return this.execute(command);
    }
    doTrackEventConversion(input) {
        const command = new commands_1.ConversionApiCommand(input);
        return this.execute(command);
    }
    doTrackFestivalFormStartEvent(input) {
        const command = new commands_1.FestivalFormStartCommand(input);
        return this.execute(command);
    }
    doTrackFestivalSuccessEvent(input) {
        const command = new commands_1.FestivalSuccessCommand(input);
        return this.execute(command);
    }
    async execute(command) {
        return command.execute(this.config);
    }
    destroy() { }
}
exports.EventTrackingService = EventTrackingService;
